import {Routes} from '@angular/router';
import {ProductInfoComponent} from './product-info/product-info.component';
import {ProductInfoGuard} from './product-info/product-info-guard';
import {ProductInfoResolver} from './product-info/product-info.resolver';
import {NotFoundComponent} from "./not-found/not-found.component";
import {AppComponent} from "./app.component";
import {MaintenanceComponent} from "./maintenance/maintenance.component";
import {MaintenanceGuard} from "./maintenance/maintenance.guard";
import { MaintenanceBannerComponent } from './maintenance-banner/maintenance-banner.component';
import { InternalDemoComponent } from './internal-demo/internal-demo.component';
import { WhitelabelComponent } from './whitelabel/whitelabel.component';
import { landingPageConfigResolver } from './landing-page-config/landing-page-config.resolver';
import { whitelabelConfigResolver } from './landing-page-config/whitelabel-config.resolver';


export const routes: Routes = [
  {path: '', redirectTo: 'product-information', pathMatch: 'full'},
  // whitelabel must come before the generic serialno/:id redirect
  {path: 'serialno/whitelabel', component: WhitelabelComponent, resolve: { whitelabelConfig: whitelabelConfigResolver }},
  {path: 'serialNo/:id', redirectTo: 'product-information/:id', pathMatch: 'full'},
  {path: 'serialno/:id', redirectTo: 'product-information/:id', pathMatch: 'full'},
  {
    path: 'internal/demo',
    component: InternalDemoComponent
  },
  {
    path: 'product-information',
    canActivate: [MaintenanceGuard],
    children: [
      {
        path: ':id',
        component: AppComponent,
        canActivate: [ProductInfoGuard]
      },
      {
        path: ':salesOrganization/:language/:id',
        component: ProductInfoComponent,
        resolve: {
          productInformation: ProductInfoResolver,
          landingPageConfig: landingPageConfigResolver
        }
      },
      {
        path: 'not-sold/:id',
        component: ProductInfoComponent,
        resolve: {
          productInformation: ProductInfoResolver
        }
      }
    ]
  },
  {
    path: 'status/maintenance',
    component: MaintenanceComponent
  },
  {
    path: 'status/maintenanceBanner',
    component: MaintenanceBannerComponent
  },
  {
    path: 'not-found/:id',
    component: NotFoundComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];